import { MigrationRequestEnum } from '@app/shared/enums/migration-request.enum';

export class SiteSkillsMigrateRequest {
  initiate: MigrationRequestEnum;
  ids: number[] = [];
}
